<template>
    <div ref="unitEntryAnalysis" style="min-height: 400px;"></div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data () {
            return {
                chart : null,
            }
        },
        props : ['data'],
        mounted () {
            this.createChart();
            this.generateData();
        },
        watch : {
            data : {
                deep : true,
                handler : 'generateData'
            }
        },
        methods : {
            generateData () {
                let length = this.chart.data.length;

                this.chart.addData(this.data.map(x=>{return{date:new Date(x.date), count:x.count}}), length)
            },
            createChart () {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                this.chart = am4core.create(this.$refs.unitEntryAnalysis, am4charts.XYChart);

                // Create axes
                let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.renderer.minGridDistance = 60;

                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

                // Create series
                let series = this.chart.series.push(new am4charts.LineSeries());
                series.dataFields.valueY = "count";
                series.dataFields.dateX = "date";
                series.tooltipText = "{count}"

                series.tooltip.pointerOrientation = "vertical";

                this.chart.cursor = new am4charts.XYCursor();
                this.chart.cursor.snapToSeries = series;
                this.chart.cursor.xAxis = dateAxis;

                //chart.scrollbarY = new am4core.Scrollbar();
                this.chart.scrollbarX = new am4core.Scrollbar();
            }
        }
    }
</script>

<style scoped>

</style>